import OtsPasswordTooltip from "./OtsPasswordTooltip"

OtsPasswordTooltip.install = Vue => {
    vue.component(OtsPasswordTooltip.name,OtsPasswordTooltip)
}


export default OtsPasswordTooltip